import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3067ed13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "data-id": "global-header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = {
  href: "/guide/",
  target: "_blank",
  ref: "noopener",
  class: "reserve nav-button"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "img/reserve.svg" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("展示場を探す"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("予約する")
], -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  href: "/inquiry/form/catalog/",
  target: "_blank",
  ref: "noopener",
  class: "catalog nav-button"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "img/catalog.svg" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("カタログ"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("請求")
], -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "img/other.svg" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("その他"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("お申込み")
], -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "menu" }
const _hoisted_16 = {
  href: "/guide/experience/",
  target: "_blank",
  ref: "noopener"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "img/menu_experience.png" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  href: "/guide/event/",
  target: "_blank",
  ref: "noopener"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "img/menu_event.png" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  href: "/lp/i-tab/",
  target: "_blank",
  ref: "noopener"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "img/menu_i-tab.png" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 0,
  class: "dialog"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "一条工務店公式ホームページトップへ移動します。", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "img/yes.png" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "img/no.png" }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: "img/logo_ichijo.svg",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDialog = true))
        })
      ]),
      _createElementVNode("nav", null, [
        _createElementVNode("a", _hoisted_4, _hoisted_7, 512),
        _createElementVNode("a", _hoisted_8, _hoisted_11, 512),
        _createElementVNode("div", {
          class: _normalizeClass([{ open: _ctx.isOpen }, "inquiry"])
        }, [
          _createElementVNode("a", {
            class: "nav-button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
          }, _hoisted_14),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_16, _hoisted_18, 512)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_19, _hoisted_21, 512)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_22, _hoisted_24, 512)
              ])
            ])
          ])
        ], 2)
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isDialog)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("a", {
                href: "/",
                target: "_blank",
                ref: "noopener",
                class: "yes",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDialog = false))
              }, _hoisted_28, 512),
              _createElementVNode("button", {
                class: "no",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDialog = false))
              }, _hoisted_30)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}